import React from 'react';

import { PillRoot } from './status-pill.styled';

export type PillVariant =
  | 'progress'
  | 'active'
  | 'selected'
  | 'new'
  | 'inProgress'
  | 'verified'
  | 'closed';

const StatusPill: React.FC<{
  variant: PillVariant;
  children: React.ReactNode;
}> = ({ variant, children }) => (
  <PillRoot $variant={variant}>{children}</PillRoot>
);

export default StatusPill;
